// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Arimo&display=swap);"]);
// Module
exports.push([module.id, ".menu-button[data-v-bcfaae38]{width:100%;height:37px;display:flex;align-items:center;text-transform:uppercase;padding-inline:10px}.icon-container[data-v-bcfaae38]{width:20px;margin-left:10px;margin-right:10px}.lock-icon[data-v-bcfaae38]{position:relative;top:-.2em;margin-right:5px}.menu-button.disabled[data-v-bcfaae38]{color:hsla(0,0%,100%,.37254901960784315);pointer-events:none}.menu-button.disabled .lock-icon[data-v-bcfaae38]{opacity:1%}", ""]);
// Exports
module.exports = exports;
